import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

const useGetPensionStatement = ({ policyNumber, enabled }) => {
  return useQuery({
    queryKey: ['pensionStatement', policyNumber],
    queryFn: async () => {
      const response = await apiClient.get('/pensions/statement', {
        params: { policy_number: policyNumber }
      });
      return response.data;
    },
    enabled: enabled && !!policyNumber,
    retry: false,
    staleTime: 0,
  });
};

export { useGetPensionStatement };
